import Popup from "../../../ui/components/Popup/Popup";
import ProgressLabel from "../../../ui/components/ProgressLabel/ProgressLabel";

export default function ArticleDeliveryStatusLabel({
	text,
	status,
	date,
	color,
	active,
	percent,
	disabled,
	style,
	onClick,
}) {
	return (
		<Popup
			content={date ? `${status}: ${date}` : status}
			disabled={!date && !status}
			color={color}
			trigger={
				<ProgressLabel
					percent={percent}
					color={color}
					active={active}
					style={{ opacity: disabled && 0.4, ...style }}
					onClick={onClick}
				>
					{text}
				</ProgressLabel>
			}
		/>
	);
}
